<template>
	<div>

		<v-row>

			<v-col cols="12" md="8">

				<v-card
					class="mx-auto"
					tile
					height="350"
				>
					<v-img
					class="white--text align-end"
					height="150px"
					src="covid-19.jpg"
					>
				<v-card-title>COVID-19 <span class="caption">(SARS-CoV-2)</span> </v-card-title>
				</v-img>
				
				<v-card-subtitle class="pb-0">Википедия</v-card-subtitle>

				<v-card-text class="text--primary">
					<div>

						<p>Пандемия началась с обнаружения в конце декабря 2019 года в городе Ухань провинции Хубэй центрального Китая первых случаев пневмонии неизвестного происхождения у местных жителей, связанных с местным рынком животных и морепродуктов Хуанань. 31 декабря 2019 года власти Китая проинформировали о вспышке неизвестной пневмонии Всемирную организацию здравоохранения (ВОЗ). С 22 января город Ухань был закрыт на карантин; с 24 января — прилегающие к Уханю городские округа. Вирус был зафиксирован во всех административных образованиях Китая провинциального уровня.</p>

					</div>
				</v-card-text>

				</v-card>

			</v-col>

			<v-col cols="12" md="4">

				<v-card
					class="mx-auto"
					tile
					height="350"
				>
					<v-img
						class="white--text align-end"
						height="150px"
						src="https://naviny.by/sites/default/files/virus-4835301_1280.jpg"
					>

						<v-card-title>Информация</v-card-title>
					</v-img>

					<v-card-subtitle class="pb-0">Таблица</v-card-subtitle>

					<v-card-text class="text--primary">
						<div>

							<p><b class="teal lighten-3">0 до 20 чел.</b></p>
							<p><b class="teal lighten-1">21 до 400 чел.</b></p>
							<p><b class="red">от 401 чел. и выше</b></p>

						</div>
					</v-card-text>

				</v-card>

			</v-col>
		</v-row>

		<WorldStats />

		<Charts />

		<v-row>
			<v-col cols="12">
				<v-card tile>
					<v-card-title>

						Степень заражённости
						<v-spacer></v-spacer>

						<v-text-field
						v-model="search"
						append-icon="mdi-magnify"
						label="Поиск"
						single-line
						hide-details
						></v-text-field>

					</v-card-title>

					<v-data-table
					:headers="headers"
					:items="covid19"
					:search="search"
					>
						<template v-slot:item.total_deaths="{ item }">
							<v-chip :color="getColor(item.total_deaths)" dark>{{ item.total_deaths }}</v-chip>
						</template>
					</v-data-table>
				</v-card>
			</v-col>
		</v-row>

</div>
</template>

<script>

	
	import WorldStats from './WorldStats.vue'
	import Charts from './Charts.vue'

	const axios = require('axios');

	export default {

		components: {
			WorldStats, Charts
		},

		data: function() {
			return {

				search: '',
				arrayStatsOnCountry: [],
				covid19: [],

				headers: [
				{
					align: 'start',
					sortable: false,
					value: 'name',
				},
					{ text: 'Страна', value: 'country' },
					{ text: 'Всего случаев', value: 'total_cases' },
					{ text: 'Новые случаи', value: 'new_cases' },
					{ text: 'Всего умерших', value: 'total_deaths' },
					{ text: 'Новых смертей', value: 'new_deaths' },
					{ text: 'Всего выздоровевших', value: 'total_recovered' },
					{ text: 'Активные случаи', value: 'active_cases' },
					{ text: 'Серьёзные/критические', value: 'serious_critical' },
					{ text: 'Всего случаев', value: 'tot_cases' },
				],		
				

			}
		},

		mounted() {
			this.getStatsOnCountry();
		},

		methods: {

			getColor(total_deaths) {
				if (total_deaths > 400) return 'red'
					else if (total_deaths > 20) return 'teal lighten-1'
								else return 'teal lighten-3'
			},
			
			getStatsOnCountry() {
				var self = this;

				axios.get('./covid/covid19.json')
					.then(function (response) {
						self.covid19 = response.data.covid19;
						console.log(response.data)
						
					})
					.catch(function (error) {
						console.log(error)
					})
					.finally(function () {

					});
			}
			
		}
	}
</script>

<style>
	.v-sheet--offset {
		top: -24px;
		position: relative;
	}
</style>